<template>
    <Layout>
        <div class="row">
            <div class="col-md-12">
              <PageHeader :title="title" :items="items"/>
                 <b-card>
                    <div v-if="trainees.total > 0" class="row mb-2">
                        <div class="col-sm-8">
                            <span class="badge badge-success mr-2">Total Search Data Found: {{ trainees.total }}</span>
                            <download-excel
                                    class="btn btn-light mr-2"
                                    :fetch="fetchData"
                                    :fields="trainee_fields"
                                    :meta="json_meta"
                                    :before-generate="startDownload"
                                    :before-finish="finishDownload"
                                    worksheet="Trainee"
                                    name="trainee-batch.xls">
                                Download All Trainee\TNA
                            </download-excel>
                            <b-dropdown variant="default" style=" background-color: #d4d4d4; border-color: #8c8c8c;">
                                <template v-slot:button-content>
                                    <i class="fa fa-cog"></i>
                                </template>
                                <b-dropdown-form style="width: 207px !important; overflow-y: auto">
                                    <span v-for="(checkboxArray, index) in checkboxArrays" :key="index" class="ml-3">
                                        <input type="checkbox" v-model="selected" :value="checkboxArray" :id="checkboxArray">&nbsp;{{ checkboxArray }} <br>
                                    </span>
                                </b-dropdown-form>
                            </b-dropdown>
                        </div>
                    </div>

                    <div class="scrollable-table table-responsive" style="overflow-x: auto">
                        <table class="table table-centered table-striped">
                            <thead>
                            <tr>
                                <th>Sl</th>
                                <th v-if="isVisible('Form No.')">Form No.</th>
                                <th v-if="isVisible('Household Number')">Household Number</th>
                                <th v-if="isVisible('Name')">Name</th>
                                <th v-if="isVisible('NID')">NID(ID Type)</th>
                                <th v-if="isVisible('Mobile')">Mobile</th>
                                <th v-if="isVisible('Gender')">Gender</th>
                                <th v-if="isVisible('Father Name')">Father Name</th>
                                <th v-if="isVisible('Mother Name')">Mother Name</th>
                                <th v-if="isVisible('Village')">Village</th>
                                <th v-if="isVisible('Mouza')">Mouza</th>
                                <th v-if="isVisible('Rep Name')">Rep. Name</th>
                                <th v-if="isVisible('Rep Father Name')">Rep. Father/Husband Name</th>
                                <th v-if="isVisible('Rep Mother Name')">Rep Mother Name</th>
                                <th v-if="isVisible('Rep Relation')">Rep Relation</th>
                                <th v-if="isVisible('Rep DOB')">Rep DOB</th>
                                <th v-if="isVisible('Rep Gender')">Rep Gender</th>
                                <th v-if="isVisible('Rep NID')">Rep NID</th>
                                <th v-if="isVisible('Rep Mobile')">Rep Mobile</th>
                                <th v-if="isVisible('Field Book')">Field Book</th>
                                <th v-if="isVisible('Batch')">Batch</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(trainee, index) in trainees.data" :key="index">
                                <td>{{ trainees.from + index }}</td>
                                <td v-if="isVisible('Form No.')">{{ trainee.form_no }}</td>
                                <td v-if="isVisible('Household Number')">{{ trainee.household_number }}</td>
                                <td v-if="isVisible('Name')">
                                    <router-link :to="{name: 'traineeView',params: { trainee_id: trainee.id }}" tag="a" title="Trainee Details" target="_blank">
                                        <span v-for="image in trainee.files" :key="image.id" class="mr-1">
                                            <span v-if="image.file_tag === '1'">
                                              <img class="rounded-circle" :src="image.name" alt="" width="30px" height="30px"/>
                                            </span>
                                        </span>
                                        {{ trainee.name }}
                                    </router-link>
                                </td>
                                <td v-if="isVisible('NID')">{{ trainee.nid }}({{ trainee.id_type }})</td>
                                <td v-if="isVisible('Mobile')">{{ trainee.mobile }}</td>
                                <td v-if="isVisible('Gender')">{{ trainee.gender.desc }}</td>
                                <td v-if="isVisible('Father Name')">{{ trainee.father_husband_name }}</td>
                                <td v-if="isVisible('Mother Name')">{{ trainee.mother_name }}</td>
                                <td v-if="isVisible('Village')">{{ trainee.village.desc }}</td>
                                <td v-if="isVisible('Mouza')">{{ trainee.mouza.desc }}</td>
                                <td v-if="isVisible('Rep Name')">
                                    <span v-for="image in trainee.files" :key="image.id" class="mr-1">
                                        <span v-if="image.file_tag === '2'">
                                          <img class="rounded-circle" :src="image.name" alt="" width="30px" height="30px"/>
                                        </span>
                                    </span>
                                    {{ trainee.rep_name }}
                                </td>
                                <td v-if="isVisible('Rep Father Name')">{{ trainee.rep_father_husband_name }}</td>
                                <td v-if="isVisible('Rep Mother Name')">{{ trainee.rep_mother_name }}</td>
                                <td v-if="isVisible('Rep Relation')"><span v-if="trainee.family_relation !== null">{{ trainee.family_relation.desc }}</span></td>
                                <td v-if="isVisible('Rep DOB')">{{ trainee.rep_dob }}</td>
                                <td v-if="isVisible('Rep Gender')"><span v-if="trainee.rep_gender !== null">{{ trainee.rep_gender.desc }}</span></td>
                                <td v-if="isVisible('Rep NID')"><span v-if="trainee.rep_nid !== null">{{ trainee.rep_nid }}({{ trainee.rep_id_type }})</span></td>
                                <td v-if="isVisible('Rep Mobile')">{{ trainee.rep_mobile }}</td>
                                <td v-if="isVisible('Field Book')">{{ trainee.field_book_sl }}</td>
                                <td v-if="isVisible('Batch')">{{trainee.trade_desc + " | " + "Batch No: " + trainee.batch_no }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <h5 v-if="trainees.total === 0" class="text-center text-secondary">
                        No Data Found
                    </h5>
                    <div class="float-right">
                        <pagination :data="trainees" :limit="2" @pagination-change-page="getResults"></pagination>
                    </div>
                </b-card>
            </div>
        </div>
    </Layout>
</template>

<script>

    import appConfig from "@src/app.config";
    import Layout from "@layouts/main";
    import PageHeader from "@components/page-header";
    import http from "@state/http";

    export default {
        page: {
            title: "Male/Female Trainee List",
            meta: [{name: "description", content: appConfig.description}]
        },
        components: {Layout, PageHeader},
        data() {
            return {
                title: "Search Trainee",
                items: [
                    {
                        text: "Dashboard",
                        href: "/"
                    },
                    {
                        text: "Trainee",
                        active: true
                    }
                ],
                trainees: {},
                trainee: {},
                search_data: {
                  c_gender_id: '',
                },
                trainee_fields: {
                    'Form No': 'form_no',
                    'Household Number': 'household_number',
                    'Name': 'name',
                    'ID Type': 'id_type',
                    'NID': 'nid',
                    'Mobile': 'mobile',
                    'Gender': 'gender.desc',
                    'Father Name': 'father_husband_name',
                    'Mother Name': 'mother_name',
                    'Marital': 'maritial_status.desc',
                    'Religion': 'religion.desc',
                    'Education': 'education.desc',
                    'Occupation': 'occupation.desc',
                    'Yearly Income': 'yearly_income',
                    'Village': 'village.desc',
                    'Mouza': 'mouza.desc',
                    'Union': 'union.desc',
                    'Affected Plot': 'affected_plots',
                    'Affected Khatians': 'affected_khatians',
                    'Affected Mouzas': 'affected_mouzas',
                    'Previous Training': {
                        callback: (value) => {
                            if (value.previous_training === 0) {
                                return `No`;
                            } else {
                                return `Yes`;
                            }
                        }
                    },
                    'Previous Training Duration': 'previous_training_duration',
                    'Specific Skills': 'specific_skills',
                    'Rep. Name': 'rep_name',
                    'Rep Gender': {
                        callback: (value) => {
                            if (value.rep_gender !== null) {
                                return `${value.rep_gender.desc}`;
                            } else {
                                return ``;
                            }
                        }
                    },
                    'Rep DOB': 'rep_dob',
                    'Rep Father Name': 'rep_father_husband_name',
                    'Rep Mother Name': 'rep_mother_name',
                    'Rep Marital': {
                        callback: (value) => {
                            if (value.rep_maritial_tatus !== null) {
                                return `${value.rep_maritial_tatus.desc}`;
                            } else {
                                return ``;
                            }
                        }
                    },
                    'Rep Religion': {
                        callback: (value) => {
                            if (value.rep_religion !== null) {
                                return `${value.rep_religion.desc}`;
                            } else {
                                return ``;
                            }
                        }
                    },
                    'Rep Education': {
                        callback: (value) => {
                            if (value.rep_education !== null) {
                                return `${value.rep_education.desc}`;
                            } else {
                                return ``;
                            }
                        }
                    },
                    'Rep Occupation': {
                        callback: (value) => {
                            if (value.rep_occupation !== null) {
                                return `${value.rep_occupation.desc}`;
                            } else {
                                return ``;
                            }
                        }
                    },
                    'Rep Relation': {
                        callback: (value) => {
                            if (value.family_relation !== null) {
                                return `${value.family_relation.desc}`;
                            } else {
                                return ``;
                            }
                        }
                    },
                    'Rep ID Type': {
                        callback: (value) => {
                            if (value.rep_nid !== null) {
                                return `${value.rep_id_type}`;
                            } else {
                                return ``;
                            }
                        }
                    },
                    'Rep NID': {
                        callback: (value) => {
                            if (value.rep_nid !== null) {
                                return `${value.rep_nid}`;
                            } else {
                                return ``;
                            }
                        }
                    },
                    'Rep Mobile': 'rep_mobile',
                    'Field Book': 'field_book_sl',
                    'Field Book Sub Serial': 'c_field_book_sub_serial_id',
                    'Batch' : {
                        callback: (value) => {
                            if(value.trade_desc == null){
                                return ``
                            }else{
                                return `${value.trade_desc} | Batch No: ${value.batch_no}`;
                            }
                        }
                    },
                },
                json_meta: [
                    [
                        {
                            'key': 'charset',
                            'value': 'utf-8'
                        }
                    ]
                ],
                flag: false,
                checkboxArrays: ['Form No.', 'Household Number', 'Name', 'NID', 'Mobile', 'Gender', 'Father Name', 'Mother Name', 'Village', 'Mouza', 'Rep Name', 'Rep Father Name', 'Rep Mother Name', 'Rep Relation', 'Rep DOB', 'Rep Gender', 'Rep NID', 'Rep Mobile', 'Field Book', 'Batch'],
                selected: ['Form No.', 'Household Number', 'Name', 'Father Name', 'Village', 'Rep Name', 'Rep Father Name', 'Batch'],
            };
        },


        mounted() {
            this.search();
        },
        methods: {
             async search() {
            this.search_data.c_gender_id = this.$route.params.c_gender_id;
               await http.post("api/trainees/gender", this.search_data).then(response => {
                    if (!response.error) {
                        this.flag = true;
                        this.trainees = response.data.trainees;
                    }
                });
            },
            async getResults(page = 1) {
              // await http.get('api/trainees/gender/'+this.search_data.c_gender_id+'/?page=' + page)
              await http.post('api/trainees/gender?page=' + page, this.search_data)
                    .then(response => {
                        this.flag = true;
                        this.trainees = response.data.trainees;
                    });
            },
            async fetchData() {
                this.search_data.download_ex = 'download';
                const response = await http.post("api/trainees/gender", this.search_data);
                return response.data.trainees;
            },
            startDownload() {
                alert('It will take some time, Loading...');
            },
            finishDownload() {
                alert('Download completed.');
            },
            isVisible(row) {
                const matchedValue = this.checkboxArrays.find(
                    v => row === v
                );

                if (!matchedValue) {
                    return true;
                }
                return this.selected.includes(matchedValue);
            }
        },
        computed: {
            userPermission() {
                return this.$store.state.user
            }
        },
        created() {
            this.$store.dispatch('getUserPermission')
        },
    };
</script>
